import { z } from 'zod';
/**
 * Lifecycle of a bridge login challenge. A challenge is created `Pending` by the
 * unauthenticated bridge, moved to `Approved`/`Denied` by an authenticated user
 * with MCP permission, then `Consumed` once the bridge redeems it for a credential.
 */
export var McpChallengeState;
(function (McpChallengeState) {
    McpChallengeState["Pending"] = "Pending";
    McpChallengeState["Approved"] = "Approved";
    McpChallengeState["Denied"] = "Denied";
    McpChallengeState["Consumed"] = "Consumed";
})(McpChallengeState || (McpChallengeState = {}));
const unsafeDisplayCharacterRegex = /[\p{Cc}\p{Cf}\p{Zl}\p{Zp}\p{Cs}]/u;
function claimedDeviceFieldSchema(maximumLength) {
    return z
        .string()
        .trim()
        .min(1)
        .max(maximumLength)
        .refine((value) => !unsafeDisplayCharacterRegex.test(value), {
        message: 'Must not contain control or formatting characters',
    });
}
/**
 * Client-claimed details shown on the approval page to help the user recognize
 * the machine asking for access. These values are descriptive, not verified.
 */
export const McpDeviceInfoSchema = z
    .object({
    hostname: claimedDeviceFieldSchema(255),
    platform: claimedDeviceFieldSchema(64),
    client: claimedDeviceFieldSchema(64),
})
    .strict();
//# sourceMappingURL=challenge.js.map